import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AllProviders } from './utils/composeProviders';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AllProviders>
    <App />
    </AllProviders>
);


